import { MutateOptions, useMutation } from '@tanstack/react-query';
import { UniversalChatMessageCreateInput, UniversalChatMessageCreatePayload } from 'gql/graphql';
import { gql } from 'graphql-request';
import { TGenericError } from 'types/TGenericError';
import clientUtil from 'utils/clientUtil';

type TVariables = UniversalChatMessageCreateInput;
type TData = UniversalChatMessageCreatePayload;

export const useUniversalChatMessageCreate = (
  options: MutateOptions<TData, TGenericError, TVariables, unknown> = {}
) => {
  const client = clientUtil();

  const graphql = gql`
    mutation universalChatMessageCreate($input: UniversalChatMessageCreateInput!) {
      universalChatMessageCreate(input: $input) {
        errors
        errorCode
        success
        thread {
          id
        }
      }
    }
  `;

  return useMutation<TData, TGenericError, TVariables, unknown>({
    ...options,
    mutationFn: (input: TVariables) =>
      client.request({
        data: {
          gql: graphql,
          variables: { input }
        }
      })
  });
};
